<template>
  <v-app>
    <div>
      <v-app-bar
          color="#160F29"
          dense
          dark
      >
        <v-btn class="ma-2 white--text" to="/">
          <v-icon left>mdi-home</v-icon>
          Thetafarmer
        </v-btn>

        <v-btn class="ma-2 white--text" :to="{hash: '#farm'}" @click.native="anchorHashCheck">
          Farming 🚜
        </v-btn>

        <v-btn class="ma-2 white--text" :to="{hash: '#seed'}" @click.native="anchorHashCheck">
          Seeding 🌱
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn icon v-if="user" class="ma-2" to="/admin">
          <v-icon>mdi-lock</v-icon>
        </v-btn>

        <v-btn class="ma-2" text href="https://discord.gg/vXmkCqm" target="_blank">
          <v-icon left>mdi-discord</v-icon>
          <span class="hidden-sm-and-down">Discord</span>
        </v-btn>
      </v-app-bar>
    </div>
    <v-main>
        <transition name="slide-fade">
          <router-view></router-view>
        </transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
  }),
  methods: {
    anchorHashCheck() {
      if (window.location.hash === this.$route.hash) {
        const el = document.getElementById(this.$route.hash.slice(1))
        if (el) {
          window.scrollTo(0, el.offsetTop)
        }
      }
    },
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    }
  },
  created() {

  },
  mounted() {
    this.anchorHashCheck()
  }
}
</script>

<style>

</style>